import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer = () => {
  const { language } = useLanguage();

  return (
    <footer className="text-white" style={{ backgroundColor: '#5b6770' }}>
      <div className="max-w-[1400px] mx-auto px-10 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Column 1: Logo & Tagline */}
          <div className="space-y-3">
            <p
              className="text-lg font-bold tracking-wider"
              style={{ fontFamily: "'Bank Gothic', 'Impact', sans-serif", letterSpacing: '2px' }}
            >
              OCEAN PEAK GROUP
            </p>
            <p
              className="text-xl text-white italic"
              style={{ fontFamily: "'Eurostile', 'Arial', sans-serif" }}
            >
              Into the Depths, Beyond the Expected.
            </p>
            <p
              className="text-sm text-white/60"
              style={{ fontFamily: "'Eurostile', 'Arial', sans-serif" }}
            >
              {language === 'fr' ? 'Partenaire de transformation industrielle' : 'Industrial investment partnership'}
            </p>
          </div>

          {/* Column 2: Connect */}
          <div>
            <h4
              className="text-sm font-bold mb-4 uppercase tracking-wider"
              style={{ fontFamily: "'Novecento Sans Wide', 'Arial', sans-serif", letterSpacing: '2px' }}
            >
              Connect
            </h4>
            <div className="space-y-3">
              <p
                className="text-sm text-white/70"
                style={{ fontFamily: "'Eurostile', 'Arial', sans-serif" }}
              >
                {language === 'fr' ? "Pour les opportunités d'investissement et de partenariat, contactez-nous." : "For investment and partnership opportunities, get in touch."}
              </p>
              <div className="flex items-center space-x-3">
                <Link
                  to="/contact"
                  className="text-white/70 hover:text-white transition-all text-sm"
                  style={{ fontFamily: "'Novecento Sans Wide', 'Arial', sans-serif" }}
                >
                  {language === 'fr' ? 'Contact' : 'Contact'}
                </Link>
                <a
                  href="https://www.linkedin.com/company/oceanpeak-capital-sas/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 bg-white/10 hover:bg-white/20 border border-transparent rounded flex items-center justify-center transition-all"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect width="4" height="12" x="2" y="9"/><circle cx="4" cy="4" r="2"/></svg>
                </a>
              </div>
            </div>
          </div>

          {/* Column 3: Legal */}
          <div className="md:text-right">
            <h4
              className="text-sm font-bold mb-4 uppercase tracking-wider"
              style={{ fontFamily: "'Novecento Sans Wide', 'Arial', sans-serif", letterSpacing: '2px' }}
            >
              {language === 'fr' ? 'Légal' : 'Legal'}
            </h4>
            <div className="space-y-3">
              <Link
                to="/legal"
                className="block text-white/70 hover:text-white transition-all text-sm"
                style={{ fontFamily: "'Novecento Sans Wide', 'Arial', sans-serif" }}
              >
                {language === 'fr' ? 'Mentions légales' : 'Legal'}
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-6 pt-4 border-t border-white/10 text-center">
          <p
            className="text-sm text-white/50"
            style={{ fontFamily: "'Novecento Sans Wide', 'Arial', sans-serif" }}
          >
            {language === 'fr' ? '© 2026 Ocean Peak Group. Tous droits réservés.' : '© 2026 Ocean Peak Group. All rights reserved.'}
          </p>
        </div>
      </div>
    </footer>
  );
};
